import { s as makeRestApiRequest } from "./utils2.mjs";

//#region src/api/api-keys.ts
async function getApiKeys(context, options = {}) {
	const { ownerIds, ...rest } = options;
	return await makeRestApiRequest(context, "GET", "/api-keys", {
		...rest,
		...ownerIds?.length ? { ownerIds: ownerIds.join(",") } : {}
	});
}
async function getApiKeyScopes(context) {
	return await makeRestApiRequest(context, "GET", "/api-keys/scopes");
}
async function createApiKey(context, payload) {
	return await makeRestApiRequest(context, "POST", "/api-keys", payload);
}
async function deleteApiKey(context, id) {
	return await makeRestApiRequest(context, "DELETE", `/api-keys/${id}`);
}
async function updateApiKey(context, id, payload) {
	return await makeRestApiRequest(context, "PATCH", `/api-keys/${id}`, payload);
}
async function rotateApiKey(context, id) {
	return await makeRestApiRequest(context, "POST", `/api-keys/${id}/rotate`);
}

//#endregion
export { rotateApiKey as a, getApiKeys as i, deleteApiKey as n, updateApiKey as o, getApiKeyScopes as r, createApiKey as t };
//# sourceMappingURL=api-keys.mjs.map